<div class="Footer_bottom">
  <ng-container *ngFor="let item of homeData">
    <section class="first-section page-hero-section page-hero-section--split" *ngIf="showHomeSection(item, 1)">
      <div class="container-fluid px-0 overflow-hidden">
        <div class="row justify-content-end align-items-center">
          <div class="col-md-5">
            <div class="heading-box">
              <h1 class="page-hero-title text-white">{{item?.title}}</h1>
              <p class="page-hero-subtitle cms-content" [innerHTML]="item?.subTitle"></p>
              <button class="btn button d-none d-flex align-items-center justify-content-center mb-3 text-white started-btn rounded-pill" (click)="openSignUpForm()">
                <span class="text">{{item?.linkTitle}}</span>
              <span class="d-none"><svg id="Group_7" data-name="Group 7" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path id="Path_1" data-name="Path 1" d="M0,0H24V24H0Z" fill="none"/>
                <path id="Path_2" data-name="Path 2" d="M16,9.414,7.4,18.021,5.983,16.607,14.589,8H7V6H18V17H16Z"/>
              </svg>
              </span>
              </button>
            </div>
          </div>
          <div class="col-md-6 pe-3 pe-md-4 text-end">
            <img [src]="item?.banner" class="img-fluid w-100 home-banner" alt="">
          </div>
        </div>
      </div>
    </section>

    <section class="about-section" *ngIf="showHomeSection(item, 2)">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-6">
            <h2 class="fs-32 fw-600 mb-3" style="color: #00625F;">{{item?.title}}</h2>
            <p class="color-44 fs-14 mb-sm-4" [innerHTML]="stripHtmlTagsForCard(item?.subTitle,500)"></p>
            <button class="btn learn-btn mb-3 rounded-pill" routerLink="/about-us">{{item?.linkTitle}}</button>
          </div>
      <div class="col-md-6">
        <div class="colored-box colored-box--media position-relative">

          <!-- Video Embed: Shows automatically if the video is available/valid -->
          <iframe *ngIf="videoEmbedValid" class="iframe_video w-100" width="500" height="300" [src]="url"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen>
          </iframe>

          <!-- Fallback Image: Only renders if the video is NOT available/valid -->
          <img *ngIf="!videoEmbedValid" [src]="item?.banner || videoPosterUrl" class="video-poster-img" alt="Sustainability">

        </div>
      </div>
        </div>
      </div>
    </section>

    <section *ngIf="showHomeSection(item, 3)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <img [src]="item?.banner" class="img-fluid shadow-sm home-section-banner" alt="">
          </div>
        </div>
      </div>
    </section>

    <section class="about-section" *ngIf="showHomeSection(item, 4)">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-10 text-center">
            <h2 class="ps-sm-3 mb-sm-4 fw-600" style="color: #00625F;">{{item?.title}}</h2>
            <p class="color-44 fs-14 mb-4 text-center" [innerHTML]="stripHtmlTagsForCard(item?.subTitle,-1)"></p>
          </div>
          <div class="col-12">
            <div id="container">
            <a routerLink="/ourpartners" class="photobanner mb-3">
              <ng-container *ngFor="let partner of partnerData">
                <img class="me-5 partner-img" [src]="partner?.image" [alt]="partner?.name || 'Partner'">
              </ng-container>
            </a>
            </div>
<div class="text-center">
  <button class="btn learn-btn my-3 rounded-pill" routerLink="/ourpartners">{{item?.linkTitle}}</button>
</div>
          </div>
        </div>
      </div>
    </section>



    <section class="impact-section" *ngIf="showHomeSection(item, 5)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <h2 class="text-primary fs-32 fw-600 text-center mb-5">{{item?.title}}</h2>
          </div>
          <div class="col-lg-3 col-md-6" *ngFor="let item of ourImpactData">
            <div class="mb-3 border-0 position-relative">
              <img [src]="item.image" class="img-fluid impact-img" alt="">
                <div class="position-absolute impact-content" style="top: 10px; left: 20px;">
                  <p class="m-0" style="font-size: 14px; color: white;">{{item.name}}</p>
                  <div class="fw-bold" style="font-size: 40px; color: white;">{{item['indicatorsCount'] ? item['indicatorsCount'] : 0}}</div>
                </div>
            </div>
          </div>
          <div class="text-center mt-4">
            <button class="btn d-flex align-items-center justify-content-center explore-btn rounded-pill m-auto" (click)="toDashboard()">
              <span>
                <svg class="me-1" id="dashboard_black_24dp" xmlns="http://www.w3.org/2000/svg" width="17.652" height="17.652" viewBox="0 0 17.652 17.652">
                  <path id="Path_7601" data-name="Path 7601" d="M0,0H17.652V17.652H0Z" fill="none"/>
                  <path id="Path_7602" data-name="Path 7602" d="M3,10.355H8.884V3H3Zm0,5.884H8.884V11.826H3Zm7.355,0h5.884V8.884H10.355ZM10.355,3V7.413h5.884V3Z" transform="translate(-0.793 -0.793)"/>
                </svg>
              </span>
               Explore</button>
          </div>
        </div>
      </div>
    </section>

    <section id="impact" *ngIf="showHomeSection(item, 6)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="text-center impact-title">
              <h2 class="text-primary fs-32 ps-sm-3 mb-sm-4 fw-600">{{item?.title}}</h2>
              <p class="color-44 fs-14 mb-4 text-center" [innerHTML]="stripHtmlTagsForCard(item?.subTitle,-1)"></p>
            </div>
          </div>
        </div>
      </div>
    <div class="container">
      <div class="row text-center impact-stories-row justify-content-center g-3">
        <ng-container *ngFor="let items of impactData; let i = index">
        <div class="col-md-3 impact-story-col" *ngIf="i <= 2">
          <div class="card-bg h-100">
            <div class="card h-100 card-hover impact-card border-0 shadow-sm">
              <div class="position-relative main-img">
                <img [src]="items?.banner" class="card-img-top rounded-0 img-fluid card-img" alt="...">
              </div>
              <div class="card-body impact-card-body">
                <h6 class="text-white impact-card-title">{{items?.title}}</h6>
                <p class="card-text text-white impact-card-text" [innerHTML]="stripHtmlTagsForCard(items?.description ,150)"></p>
              </div>
              <div class="text-center card-footer impact-card-footer">
                <button class="btn read-btn read-btn--impact text-white rounded-pill" routerLink="/related-stories" [queryParams]="{ id: items?.id}">Read More</button>
              </div>
            </div>
          </div>
        </div>
        </ng-container>
        <div class="col-12 text-center">
          <button class="btn rounded-pill view-btn" routerLink="/impact-stories">View All</button>
        </div>
      </div>
    </div>
    </section>

    <section class="team-section" *ngIf="showHomeSection(item, 7)">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="text-center">
              <h2 class="text-primary fs-32 mb-sm-4 fw-600">{{item?.title}}</h2>
              <p class="text-center color-44 fs-14 team-section-subtitle">{{item?.subTitle}}</p>
            </div>
          </div>
          <div class="col-12 team-section-nav">
            <button id="prev-btn" class="btn team-nav-btn me-2" (click)="nextImages('backward')"><</button>
            <button class="btn team-nav-btn" (click)="nextImages('forward')">></button>
          </div>
        </div>
        <div class="row team-members-row justify-content-center g-3" *ngIf="item?.model == 'Teammember'">
          <div class="col-md-3 team-member-col" *ngFor="let emp of imgData; let i = index" id="trans">
            <div class="card-bg h-100">
              <div class="card h-100 card-hover team-card border-0 shadow-sm">
                <div class="position-relative team-card-img">
                  <img [src]="emp?.profile" class="card-img-top img-fluid team-member-photo" alt="">
                </div>
                <div class="card-body team-card-body">
                  <h6 class="text-white team-member-name">{{emp?.name}}</h6>
                  <p class="card-text text-white team-member-designation mb-0">{{emp?.designation}}</p>
                </div>
                <div class="card-footer team-card-footer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="contact-section" *ngIf="showHomeSection(item, 8)">
      <div class="container">
        <div class="row justify-content-center align-items-center g-4">
          <div class="col-md-6">
            <div class="contact-form-panel">
              <h2 class="contact-form-title">{{item?.title}}</h2>
              <p class="contact-form-subtitle">{{item?.subTitle}}</p>
              <form class="contact-form" [formGroup]="contactUsForm">
                <div class="row g-2">
                  <div class="col-md-6 contact-form-field">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Name</mat-label>
                      <input type="text" placeholder="Enter your name" matInput formControlName="fullname" minlength="2" maxlength="20" (keypress)="alphabetsOnly($event)" required>
                    </mat-form-field>
                    <mat-error class="home-invalid f-12" *ngIf="contactUsForm.controls['fullname'].value == '' && contactUsForm.controls['fullname'].touched">
                      Name is Required *
                    </mat-error>
                  </div>
                  <div class="col-md-6 contact-form-field">
                    <mat-form-field appearance="outline" class="example-full-width w-100">
                      <mat-label>Email</mat-label>
                      <input type="email" (input)="validateMethod('emailId')" placeholder="example@gmail.com" matInput formControlName="emaiID" required>
                    </mat-form-field>
                    <mat-error class="home-invalid f-12" *ngIf="contactUsForm.controls['emaiID'].value == '' && contactUsForm.controls['emaiID'].touched">
                      Email is required *
                    </mat-error>
                    <mat-error class="home-invalid f-12" *ngIf="contactUsForm.controls['emaiID'].value != '' && contactUsForm.controls['emaiID'].touched && contactUsForm.controls['emaiID'].status == 'INVALID'">
                      Please enter a valid email.
                    </mat-error>
                  </div>
                  <div class="col-12 contact-form-field">
                    <mat-form-field appearance="outline" class="example-full-width w-100 contact-message-field">
                      <mat-label>Message</mat-label>
                      <textarea matInput placeholder="Enter your message" formControlName="message" rows="3" (keypress)="restrictSpecialChar($event)" required></textarea>
                    </mat-form-field>
                    <mat-error class="home-invalid f-12" *ngIf="contactUsForm.controls['message'].value == '' && contactUsForm.controls['message'].touched">
                      Message is Required *
                    </mat-error>
                  </div>
                </div>
                <button type="submit" class="btn btn-primary w-100 rounded-pill submit-btn contact-submit-btn" [disabled]="contactUsForm.invalid" (click)="gdprConfirmation()">Submit</button>
                <div class="contact-form-footer">
                  <ng-container *ngIf="contactDisplayEmail">
                    <div class="contact-form-email" *ngIf="!contactEmailLoading; else contactEmailLoader">
                      <img src="../../../assets/images/email-icon.svg" class="contact-form-email-icon" alt="">
                      <div>
                        <div class="contact-form-email-label">Email:</div>
                        <a class="contact-form-email-link" [href]="contactMailtoHref">{{ contactDisplayEmail }}</a>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #contactEmailLoader>
                    <div class="contact-form-email contact-form-email-loading" aria-busy="true" aria-label="Loading contact email">
                      <span class="contact-email-loader-spinner"></span>
                    </div>
                  </ng-template>
                  <span class="contact-form-privacy pointer" (click)="privacyStatement()"><u>Privacy Statement</u></span>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-6">
            <img [src]="item?.banner" class="img-fluid contact-img" alt="">
          </div>
        </div>
      </div>
    </section>
  </ng-container>
</div>